module.exports = __webpack_public_path__ + "img/file.54eb6ec9.jpg";